export default __webpack_public_path__ + "menu-configure-icon.bd2d3cc3d7bb26f35bd6a3094b318afb.svg";